import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ApiUrl } from "../../Constants/Weburl";
import "../../CssPage/Livesettings.css";
import SettingSidebar from "../../components/Setttingsidebar";
import CustomContainer from "../../components/Customsettingscontain";
import CustomCard from "../../components/Customsettingscard";
import CustomInput from "../../components/Custominput";
import CustomButton from "../../components/CustomButton";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";

export default function LiveSettings() {

    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const token = localStorage.getItem("adminToken");
            const res = await axios.get(
                `${ApiUrl}api/admin/livestreamsettings`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (res.data.success) {
                setSettings(res.data.data);
            }
        } catch (err) {
            console.log("fetchSettings error:", err);
        } finally {
            setLoading(false);
        }
    };

    const saveSettings = async () => {
        setSaving(true);
        try {
            const token = localStorage.getItem("adminToken");
            await axios.post(
                `${ApiUrl}api/admin/livestreamsettings`,
                settings,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setSaved(true);
            setTimeout(() => setSaved(false), 2000);
        } catch (err) {
            console.log("saveSettings error:", err);
        } finally {
            setSaving(false);
        }
    };

    return (
       

                <Layout>

                     <SettingsPageShell
                            // title="Live Settings"
                            wrapperClassName="rr-wrapper-live"
                          >

                           
                      {loading ? (
                    <div className="ls-wrapper">
                        <p>Loading...</p>
                    </div>
                ) : (

                        <div className="ls-wrapper">

                            <div className="ls-section-title">LIVESTREAM</div>

                            <div className="ls-note">
                                <p>* Set 0 as a value either in Timeout Minutes or Min. Viewers required to stop Livestream Timeout function.</p>
                                <p>* If you turn ON dummy live streams, It will display dummy lives on the app. In order to show dummy lives, There must be dummy live videos added in the list.</p>
                            </div>

                            <div className="ls-grid-3">
                                <CustomCard className="ls-card">
                                    {/* <label className="ls-label">
                                Min. Followers needed to go Live
                            </label>
                            <input */}
                                    <CustomInput
                                        label="Min. Followers needed to go Live"
                                        wrapperClassName=""
                                        labelClassName="ls-label"
                                        type="number"
                                        className="ls-input"
                                        value={settings.minFollowers}
                                        onChange={(e) =>
                                            setSettings({ ...settings, minFollowers: Number(e.target.value) })
                                        }
                                    />
                                </CustomCard>

                                {/* Min Viewers */}
                                {/* <div className="ls-card"> */}
                                <CustomCard className="ls-card">
                                    {/* <label className="ls-label">
                                        
                                    </label> */}
                                    {/* <input */}
                                    <CustomInput
                                        label="Min. Viewers Required to continue live"
                                        wrapperClassName=""
                                        labelClassName="ls-label"
                                        type="number"
                                        className="ls-input"
                                        value={settings.minViewers}
                                        onChange={(e) =>
                                            setSettings({ ...settings, minViewers: Number(e.target.value) })
                                        }
                                    />
                                </CustomCard>

                                {/* Timeout */}
                                {/* <div className="ls-card"> */}
                                <CustomCard className="ls-card">
                                    {/* <label className="ls-label">
                                        Time Out Minutes (if not get min. viewers)
                                    </label>
                                    <input */}
                                    <CustomInput
                                        label="Time Out Minutes (if not get min. viewers)"
                                        wrapperClassName=""
                                        labelClassName="ls-label"
                                        type="number"
                                        className="ls-input"
                                        value={settings.timeoutMinutes}
                                        onChange={(e) =>
                                            setSettings({ ...settings, timeoutMinutes: Number(e.target.value) })
                                        }
                                    />
                                </CustomCard>
                                {/* </div> */}
                            </div>

                            {/* ── ZEGO CLOUD Section ── */}
                            <div className="ls-section-title" style={{ marginTop: 30 }}>
                                ZEGO CLOUD SETTINGS
                            </div>
                            

                            <div className="ls-grid-2">
                                <CustomCard className="ls-card">
                                    {/* <label className="ls-label">Zego Cloud App ID</label>
                                    <input */}
                                    <CustomInput
                                        label="Zego Cloud App ID"
                                        wrapperClassName=""
                                        labelClassName="ls-label"
                                        type="password"
                                        className="ls-input"
                                        value={settings.zegoAppId || ""}
                                        onChange={(e) =>
                                            setSettings({ ...settings, zegoAppId: e.target.value })
                                        }
                                        placeholder="----------"
                                    />
                                </CustomCard>

                                <CustomCard className="ls-card">
                                    {/* <label className="ls-label">Zego Cloud App Sign</label>
                                    <input */}
                                    <CustomInput
                                        label="Zego Cloud App Sign"
                                        wrapperClassName=""
                                        labelClassName="ls-label"
                                        type="password"
                                        className="ls-input"
                                        value={settings.zegoAppSign || ""}
                                        onChange={(e) =>
                                            setSettings({ ...settings, zegoAppSign: e.target.value })
                                        }
                                        placeholder="----------"
                                    />
                                </CustomCard>
                            </div>

                            {/* Save Button */}
                            <CustomButton
                                className="ls-save-btn"
                                onClick={saveSettings}
                                disabled={saving}
                            >
                                {saving ? "Saving..." : saved ? "✅ Saved!" : "Save Settings"}
                            </CustomButton>

                        </div>
                )}
            
                </SettingsPageShell>
                </Layout>
         

    );
}